<template>



    <v-card class="ma-0 mb-6 pa-3" :border="true" flat>
        <p class="text-headline-small mb-3">Quantità</p>
        <p class="text-title-large">Bovini</p>
        <v-number-input  label="bovini_adulti" v-model="properties.bovini_adulti" :min="0" :max="200" class="mb-6" />
        <v-number-input  label="bovini_manze" v-model="properties.bovini_manze" :min="0" :max="200" class="mb-6" />
        <v-number-input  label="bovini_vitelli" v-model="properties.bovini_vitelli" :min="0" :max="200" class="mb-6" />
        <p class="text-title-large">Ovini</p>
        <v-number-input  label="ovini" v-model="properties.ovini" :min="0" :max="200" class="mb-6" />
        <p class="text-title-large">Capre</p>
        <v-number-input  label="capre" v-model="properties.capre" :min="0" :max="200" class="mb-6" />
        <p class="text-title-large">Altro</p>
        <v-number-input  label="altro" v-model="properties.altro" :min="0" :max="200" class="mb-6" />
    </v-card>

    <v-card class="ma-0 mb-6 pa-3" :border="true" flat>
        <p class="text-headline-small">Conduzione</p>

        <v-select v-model="properties.conduzione_id" :items="tipoconduzionepastore"
            label="Pastore" hide-details class="mb-3" item-title="label" />
    </v-card>


    <v-card class="ma-0 mb-6 pa-3" :border="true" flat>
        <p class="text-headline-small">Cani</p>
        <v-number-input  label="Presenza" v-model="properties.cani" :min="0" :max="200" class="mb-6" />
        <v-number-input  label="Attacchi" v-model="properties.attacchi_canidi" :min="0" :max="200" class="mb-6" />
        
    </v-card>

    <SegnalazioneCommon 
        v-model="properties" 
        :show_timestamp="false"
        :show_start_end_observation_dates="true"
    />

    <v-alert 
        v-if="props.isNew"
        type="info"
        title="Geometria"
        variant="outline"
        >
        Ricordati di modificare la geometria, dopo aver <strong class="">confermato</strong> (inserito) l'elemento
    </v-alert>

</template>

<script setup>


import SegnalazioneCommon from "@/reports/components/SegnalazioneCommon";
import baseData from '@/assets/catalog/TrackerForms.json'
import { computed, onMounted, watch } from 'vue'



const properties = defineModel()

const props = defineProps({
    "isNew": {
        type: Boolean,
        default: false
    }
})

const tipoconduzionepastore = baseData.lookup.tipoconduzionepastore




const loadDefaults = () => {

    properties.value.label = "Monticanti"
    properties.value.conduzione_id = tipoconduzionepastore[0].value

    // properties.value.predaspeciefauna = null
    // properties.value.consumato = null
    // properties.value.predasesso = null
    // properties.value.predagiovane = null
    // properties.value.predanote = ""


    // the_geom_source

}

watch(() => properties.value.specie_id, (newVal,) => {
})


onMounted(() => {

    if (props.isNew) {

        loadDefaults()
    }

})
</script>
